/**
 * It's created as alternative for v-show because after one of production deploys all elements
 * which used v-show directive were hidden and inactive which leaded to bugs
 * @param {DOM} elem - DOM element
 * @param {object} binding - value from vue directive v-updated-show
 */
export const updatedShow = (elem, binding) => {
  elem.style.display = binding.value ? '' : 'none';
};
